<template>
    <validation-provider v-slot="v" :name="name" :rules="rules" slim mode="eager">
        <div class="form-group mb-0"
             :class="{
                 'has-feedback has-error': v.errors.length,
                 'row': inline && isLabelSlot,
                 'd-flex': inline && isLabelSlot,
             }">
            <label v-if="isLabelSlot" :for="id" :class="labelClass" class="mb-0 mt-2">
                <slot name="label" />
            </label>
            <div :class="{'col-md-7':labelClass.length}">
                <textarea :id="id"
                          :name="name"
                          v-model="val"
                          :rows="rows"
                          :disabled="disabled"
                          :class="{'is-invalid': v.errors.length, 'custom-green-input-bg': !noCustomBg}"
                          class="form-control"/>
                <div class="invalid-feedback">
                    {{ v.errors[0] }}
                </div>
            </div>
        </div>
    </validation-provider>
</template>

<script>
export default {
    name: 'AppTextarea',
    props: {
        id: [String, Number],
        value: [String, Number],
        disabled: Boolean,
        noCustomBg: Boolean,
        rows: {
            type:Number,
            default: 3
        },
        inline: Boolean,
        name: String,
        rules: String
    },
    computed: {
        val: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        labelClass() {
            if (this.inline) {
                return 'col-md-3 col-form-label text-md-right';
            }

            return '';
        },
        isLabelSlot() {
            return !!this.$slots.label;
        }
    }
};
</script>
